module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = ./src/app/header/header.component.css
// module chunks = main